import { render, staticRenderFns } from "./2_information.vue?vue&type=template&id=0aa4efdf&scoped=true&"
import script from "./2_information.vue?vue&type=script&lang=js&"
export * from "./2_information.vue?vue&type=script&lang=js&"
import style0 from "./2_information.vue?vue&type=style&index=0&id=0aa4efdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa4efdf",
  null
  
)

export default component.exports